import { Typewriter } from "@/components/Typewriter";

const capabilities = [
  "AI Websites",
  "Voice Agents",
  "Automation Systems",
  "Web Applications",
  "SEO + AI Visibility",
  "Vertical SaaS",
];

function CapabilityTypewriterList() {
  return (
    <div className="capability-typewriter-inner">
      {capabilities.map((item, index) => (
        <Typewriter
          key={item}
          text={item}
          speed={45}
          deleteSpeed={28}
          startDelay={index * 180}
          delay={1400}
          loop
          cursor="_"
          className="capability-typewriter-line"
          cursorClassName="capability-typewriter-cursor"
        />
      ))}
    </div>
  );
}

export default function CapabilityStrip() {
  return (
    <section
      className="capability-typewriter-band"
      data-testid="capability-strip"
      aria-label="ForgeLayer capabilities"
    >
      <CapabilityTypewriterList />
    </section>
  );
}
